module.exports = __webpack_public_path__ + "img/agogo.9e3ca596.png";